import React from "react";
import { Navigate } from "react-router-dom";
import IdleLogoutGuard from "./components/IdleLogoutGuard";

function FranchiseProtectedRoute({ children }) {
  const franchiseData = localStorage.getItem("franchise");

  if (!franchiseData) {
    return <Navigate to="/franchise-login" replace />;
  }

  return (
    <IdleLogoutGuard
      enabled={Boolean(franchiseData)}
      authKey="franchise"
      activityKey="franchiseLastActiveAt"
      clearKeys={["franchise"]}
      redirectTo="/franchise-login"
    >
      {children}
    </IdleLogoutGuard>
  );
}

export default FranchiseProtectedRoute;
